module.exports = __webpack_public_path__ + "static/usi-logo-f2236fa0c2d2d9056a60136682e27d92.png";